import {z} from 'zod';
import {id, nullableString} from '../global/globalModels';

// Define a flexible profile image that can be either a string or an object
const profileImageFlexible = z
    .union([
        z.string(),
        z
            .object({
                url: z.string().optional(),
                path: z.string().optional(),
                src: z.string().optional(),
                // Add other common image object properties
            })
            .transform(img => {
                // Convert object to string by extracting URL-like property
                return img.url || img.path || img.src || null;
            }),
        z.null(),
    ])
    .nullable()
    .default(null);

export const bookingUserModel = z.object({
    id: id,
    firstName: z.string(),
    lastName: z.string(),
    initials: nullableString,
    profileImage: profileImageFlexible,
    guestBookingFullName: nullableString,
    guestBookingCompany: nullableString,
    guestBookingInitials: nullableString,
    guestBookingAnonymised: z.boolean().default(false),
});

export type BookingUserModel = z.infer<typeof bookingUserModel>;
